import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarImportacaoVendaConsignatarioModel } from "../models/importacaoVendaConsignatario/buscarImportacaoVendaConsignatarioModel";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalConfirmarImportacaoVendaConsignatario } from "../redux/slices/importacaoVendaConsignatario/importacaoVendaConsignatarioSlice";

export const processarImportacaoVendaConsignatario = createAsyncThunk("/ImportacaoVendaConsignatario/ProcessarImportacaoVendaConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ImportacaoVendaConsignatario/ProcessarImportacaoVendaConsignatario", payload);
    toastSucess("Dados processados com sucesso");
    dispatch(setModalConfirmarImportacaoVendaConsignatario(false))
    dispatch(setLoading(false));

    dispatch(buscarImportacaoVendaConsignatario(payload));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const importarVendaConsignatario = createAsyncThunk("/ImportacaoVendaConsignatario/ImportarVendaConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ImportacaoVendaConsignatario/ImportarVendaConsignatario", payload.value);
    toastSucess("Dados importados com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarImportacaoVendaConsignatario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarImportacaoVendaConsignatario = createAsyncThunk("/ImportacaoVendaConsignatario/BuscarImportacaoVendaConsignatario", async (args: BuscarImportacaoVendaConsignatarioModel) => {
  try {
    const data = await api.get("/ImportacaoVendaConsignatario/BuscarImportacaoVendaConsignatario", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
